import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import useEditorStore from './state-hook';
import NavbarWidthContainer from '../../shared/navbar-width-container';
import breakpoints from '../../../shared/breakpoints';

const Style = createGlobalStyle`
  .impersona-warning-prompt {
    width: 100vw;
    height: 52px;
    background: white;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
    z-index: 2500;
    ${props => (props.isLarge ? `
      position: sticky;
      top: 66px;

      &.new-nav {
        top: 105px;
      }
    ` : `
      position: relative;
      top: -79px;
    `)};

    > .nw-content-container {
      display: flex;
      align-items: center;
      font: ${props => props.theme.fontWeightRegular} 17px/110% ${props => props.theme.fontFamilyBody};

      .icon-lw-user-check {
        color: ${props => props.theme.primaryColor};
        margin-right: 16px;
        font-size: 20px;
        font-weight: ${props => props.theme.fontWeightDccc};
      }

      > span {
        overflow-x: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        min-width: 0;
        > strong {
          font-weight: ${props => props.theme.fontWeightDccc};
          margin: 0 6px;
        }
      }
    }
  }
`;

export default function ImpersonaPrompt({ newNav }) {
  const wire = useEditorStore(state => state.wire);
  const currentProfile = useEditorStore(state => state.currentProfile);
  const isLarge = useMediaQuery({ minWidth: breakpoints.largeMin });

  const author = _.get(wire, 'profile');

  if (_.get(currentProfile, 'slug') === _.get(author, 'slug')) {
    return null;
  }

  const clsName = `impersona-warning-prompt ${newNav ? 'new-nav' : ''}`;

  return (
    <>
      <Style isLarge={isLarge} />
      <NavbarWidthContainer clsName={clsName}>
        <i className="icon-lw-user-check" />
        <span>
          This wire will be published under
          <strong>{`${author.isCompanyProfile && author.organization ? author.organization : author.name}’s`}</strong>
          account.
        </span>
      </NavbarWidthContainer>
    </>
  );
}

ImpersonaPrompt.propTypes = {
  newNav: PropTypes.bool.isRequired,
};
